 //Remove this once api implemented
         //Start
           export const headers = {
                
                "OutputRecordId": {
                    "order": 0,
                    "propName": "OutputRecordId",
                    "name": "Output Record ID",
                    "hidden": false,
                    "isSorted": false,
                    "isSortedAsc": false,
                    "isDateTime": false,
                    "columnCharCss": "",
                    "searchString": "",
                    "shortName": "",
                    "isLink": false,
                    "formats": {
                        "date": "DD MMM, YYYY"
                    }
                },
                "OutputConfigurationName": {
                    "order": 0,
                    "propName": "OutputConfigurationName",
                    "name": "Output Configuration Name",
                    "hidden": true,
                    "isSorted": false,
                    "isSortedAsc": false,
                    "isDateTime": false,
                    "columnCharCss": "",
                    "searchString": "",
                    "shortName": "",
                    "isLink": false,
                    "formats": {
                        "date": "DD MMM, YYYY"
                    }
                },
                "CreationDate": {
                    "order": 1,
                    "propName": "CreationDate",
                    "name": "Creation Date",
                    "hidden": false,
                    "isSorted": false,
                    "isSortedAsc": false,
                    "isDateTime": false,
                    "columnCharCss": "",
                    "searchString": "",
                    "shortName": "",
                    "isLink": false,
                    "formats": {
                        "date": "DD MMM, YYYY"
                    }
                },
                "CreatedBy": {
                    "order": 2,
                    "propName": "CreatedBy",
                    "name": "Created By",
                    "hidden": false,
                    "isSorted": false,
                    "isSortedAsc": false,
                    "isDateTime": false,
                    "columnCharCss": "",
                    "searchString": "",
                    "shortName": "",
                    "isLink": false,
                    "formats": {
                        "date": "DD MMM, YYYY"
                    }
                },
                "OutputRecordStatus": {
                    "order": 3,
                    "propName": "OutputRecordStatus",
                    "name": "Output Record Status",
                    "hidden": false,
                    "isSorted": false,
                    "isSortedAsc": false,
                    "isDateTime": false,
                    "columnCharCss": "",
                    "searchString": "",
                    "shortName": "",
                    "isLink": false,
                    "formats": {
                        "date": "DD MMM, YYYY"
                    }
                },
                
            }

           export const data = {
                "PageIndex": 0,
                "PageSize": 10,
                "TotalCount": 47,
                "TotalPages": 5,
                "IndexFrom": 0,
                "Items": [
                    {
                        "OutputRecordId": "OR202530001",
                        "OutputConfigurationName": "ATEM_Output_Configuration_v2",
                        "CreationDate": "March 17, 2025",
                        "CreatedBy": "Centeno, Anjo L",
                        "OutputRecordStatus": "In Progress"
                    },
                    {
                        "OutputRecordId": "OR202530002",
                        "OutputConfigurationName": "ATEM_Output_Configuration_v1",
                        "CreationDate": "February 15, 2025",
                        "CreatedBy": "Centeno, Anjo L",
                        "OutputRecordStatus": "Completed"
                    },
                    {
                        "OutputRecordId": "OR202530003",
                        "OutputConfigurationName": "ATEM_Output_Configuration_v1",
                        "CreationDate": "January 25, 2025",
                        "CreatedBy": "Centeno, Anjo L",
                        "OutputRecordStatus": "Failed"
                    },
                ],
                "HasPreviousPage": false,
                "HasNextPage": true
            }

           export const pagination = {
                "PageNumber": 0,
                "PerPage": 10,
                "TotalPages": 5,
                "TotalEntries": 47,
                "HasNext": true,
                "HasPrevious": false,
                "PageSizes": [
                    10,
                    20,
                    30
                ]
            }

           export const GENERATED_FILES_DATA = {
                    "OR202530001": [
                        { name: "ATEM_Recharging_Output_OR202530001.json" },
                        { name: "InProgress_Report_OR202530001.pdf" }
                    ],
                    "OR202530002": [
                        { name: "ATEM_Recharging_Output_OR202530002.json" },
                        { name: "Completion_Summary_OR202530002.csv" }
                    ],
                    "OR202530003": [
                        { name: "ATEM_Recharging_Output_OR202530003.json" },
                        { name: "Failure_Log_OR202530003.txt" }
                    ],
                };

        //End